module.exports = __webpack_public_path__ + "static/alexandre-9e13eb1e92c389c760ee902851ccf432.png";